export default "__VITE_ASSET__DFKwDUuw__"